import React from 'react';
import { useAiRovoCurrentRouteConfiguration } from '@jira/ai-rovo_actions-selector/src/useAiRovoCurrentRouteConfiguration.tsx';
import { AISmartButtonRefresh } from '@atlassian/ai-smart-button';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useConversationAssistantSidebarApi } from '@atlassian/jira-conversation-assistant/src/ui/useConversationAssistantSidebarApi.tsx';

export const AiRovoButtonWrapperRefresh = () => {
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const configuration = useAiRovoCurrentRouteConfiguration();
	const sidebarApi = useConversationAssistantSidebarApi({});

	return (
		<AISmartButtonRefresh
			product="jira"
			cloudId={cloudId}
			orgId={orgId}
			isNav4Enabled
			sidebarApi={sidebarApi}
			productPage="jira"
			{...configuration}
		/>
	);
};
